import { withInstall } from '@jdesign-vue/utils'

import Link from './src/link.vue'

export const JdLink = withInstall(Link)
export default JdLink

export * from './src/link'
